import { withFormik } from "formik";
import React from "react";

import PageCard from "../../../General/PageCard";
import EmployerLogo from "../FormContent/EmployerLogo";

import {
  buildValidationSchema,
  bundleFormContext,
  handleSubmit,
} from "../FormContent/formHelpers";
import {
  FieldSection,
  OrganizationNameField,
  EmailField,
  PasswordField,
  AgreesToTermsField,
} from "../FormContent/RegistrationFormFields";
import RegistrationFormFooter from "../FormContent/RegistrationFormFooter";
import RFIFeaturesGraphic from "../FormContent/RFIFeaturesGraphic";

export function CommunityGreeting() {
  return (
    <div style={{ width: "90%", padding: 24 }}>
      Welcome to the
      {' '}
      <span className="bold">TALK Agency Directory</span>
      ! TALK is
      the largest and most active organization for internal Talent Acquisition
      professionals, meaning your profile will be available to 10,000+
      professionals who are looking for your services to help them hire.
      <br />
      <br />
    </div>
  );
}

const joinRecruitifiContent = [
  {
    imageURL:
      "https://recruitifi-public.s3.amazonaws.com/images/registration_icons/directory.png",
    title: "Your profile is visble to 10,000+ TA Leaders",
    alt: "Directory Visibility",
  },
  {
    imageURL:
      "https://recruitifi-public.s3.amazonaws.com/images/registration_icons/target.png",
    title: "Hiring Managers find you based on your specifications",
    alt: "Targeted Opportunities",
  },
  {
    imageURL:
      "https://recruitifi-public.s3.amazonaws.com/images/registration_icons/gold_bars.png",
    title: "Top companies invite you to work on roles directly",
    alt: "Communication Platform",
  },
];

function CommunityRegistrationForm(props) {
  const formContextProps = bundleFormContext(props);

  return (
    <PageCard
      title="TALK Agency Directory"
      footerVisible
      withImageCardHeader
      footer={<RegistrationFormFooter {...formContextProps} talk />}
      contentPadding={24}
      avatar={(
        <div style={{ marginLeft: 12 }}>
          <EmployerLogo
            logoURL="https://recruitifi-public.s3.amazonaws.com/talk.svg"
            specificStyle={{ width: 140, paddingLeft: 50 }}
          />
        </div>
      )}
    >
      <RFIFeaturesGraphic features={joinRecruitifiContent} />
      <CommunityGreeting />
      <FieldSection>
        <OrganizationNameField {...formContextProps} />
        <EmailField
          {...formContextProps}
          validationUrl="/api/v3/public/validations/individual_email?talk=true"
        />
        <PasswordField {...formContextProps} />
        <AgreesToTermsField {...formContextProps} talk />
      </FieldSection>
    </PageCard>
  );
}

const CommunityRegistrationFormWithFormik = withFormik({
  handleSubmit,
  mapPropsToValues: () => ({
    organization_name: "",
    email: "",
    password: "",
    agrees_to_terms: false,
    terms_type: "talk_agency_recruiter",
  }),
  validationSchema: buildValidationSchema([
    "organization_name",
    "email",
    "password",
    "agrees_to_terms",
  ]),
})(CommunityRegistrationForm);

export default CommunityRegistrationFormWithFormik;
